import CircleIcon from "@mui/icons-material/Circle";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link, useLocation } from "react-router-dom";
import { NAVBAR } from "../lib/constants.js";
import useNavbarPages from "../lib/hooks/useNavbarPages.js";
import { useUser } from "./UserContext.js";

export default function NavBar({ locales }) {
  const { user, isHost } = useUser();
  const { pathname } = useLocation();
  const theme = useTheme();
  const isXSmallScreen = useMediaQuery(theme.breakpoints.down("smd"));
  const pagesToShow = useNavbarPages({ locales, profile: user.profile });

  return (
    <AppBar
      position="static"
      color="backgroundContrast"
      sx={{ mb: NAVBAR.MARGIN_BOTTOM }}
    >
      <Container
        maxWidth="lg"
        sx={{ mx: "auto", px: 2, sm: { px: 3 }, lg: { px: 4 } }}
      >
        <Box
          height={NAVBAR.HEIGHT}
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {Object.entries(pagesToShow).map(([key, value]) => {
            const { isImage } = value;
            const isSelected = pathname.includes(value.route);
            const Icon = value.icon;

            return (
              <Button
                color={isSelected ? "secondary" : "primary"}
                component={Link}
                key={key}
                sx={{ height: "100%", width: "100%" }}
                state={isHost ? { id: user?.host?.id } : null}
                to={value.route}
              >
                {isXSmallScreen ? (
                  isImage ? (
                    <Box
                      component="img"
                      src={value.icon}
                      sx={{
                        borderRadius: "50%",
                        height: 30,
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <Icon fontSize="large" />
                  )
                ) : (
                  <Typography
                    component="span"
                    noWrap
                    sx={{
                      letterSpacing: { smd: 0, md: 2 },
                      position: "relative",
                    }}
                  >
                    {value.name}
                  </Typography>
                )}
                {isSelected && (
                  <CircleIcon
                    color="secondary"
                    sx={{
                      fontSize: NAVBAR.ICON_SIZE,
                      position: "absolute",
                      bottom: NAVBAR.ICON_POSITIONING,
                    }}
                  />
                )}
              </Button>
            );
          })}
        </Box>
      </Container>
    </AppBar>
  );
}
